import backlinkApi from './backlinkNewApi';

export const backlinkDomainStatusApi = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getDomainStatus: build.query({
      query: body => ({
        url: '/api_backlink/v1/domain/status',
        method: 'POST',
        body
      }),
      transformResponse: response => response?.data,
      providesTags: ['DomainStatus']
    }),
    analyzeDomain: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/domain/analyze',
        method: 'POST',
        body
      }),
      transformResponse: response => response?.data,
      invalidatesTags: ['DomainStatus'],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data) return;
          dispatch(
            backlinkDomainStatusApi.util.updateQueryData(
              'getDomainStatus',
              {
                domain_slug: arg.domain_slug,
                ...(arg.url ? { url: arg.url } : {})
              },
              () => data
            )
          );
        } catch {
          /* keep previous status; error shown in UI */
        }
      }
    })
  })
});

export const {
  useGetDomainStatusQuery,
  useAnalyzeDomainMutation
} = backlinkDomainStatusApi;
export default backlinkDomainStatusApi;
